// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2V4H4V22.0806L7.46605 19.3078L9.75 21.338L12 19.338L14.25 21.338L16.5339 19.3078L20 22.0806V4H22V2H2ZM16 9H8V7H16V9ZM9 13V11H15V13H9Z"}}]};

const BillFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bill-filled',
    ref,
    icon: element,
  },
));

BillFilledIcon.displayName = 'BillFilledIcon';

export default BillFilledIcon;
